import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserSession,
} from "amazon-cognito-identity-js";

export const userPool = new CognitoUserPool({
  UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
});

export function signIn(email: string, password: string): Promise<CognitoUser> {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    const authDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
    });
    user.authenticateUser(authDetails, {
      onSuccess: () => resolve(user),
      onFailure: reject,
    });
  });
}

export function signOut(): void {
  userPool.getCurrentUser()?.signOut();
}

export function getCurrentToken(): string | null {
  const user = userPool.getCurrentUser();
  if (!user) return null;
  let token: string | null = null;
  user.getSession((err: Error | null, session: CognitoUserSession | null) => {
    if (!err && session?.isValid()) {
      token = session.getIdToken().getJwtToken();
    }
  });
  return token;
}

export function getCurrentUser(): { email: string } | null {
  const user = userPool.getCurrentUser();
  if (!user) return null;
  let email: string | null = null;
  user.getSession((err: Error | null, session: CognitoUserSession | null) => {
    if (!err && session?.isValid()) {
      email = session.getIdToken().payload["email"] as string;
    }
  });
  return email ? { email } : null;
}

export function refreshSession(): Promise<string | null> {
  return new Promise((resolve) => {
    const user = userPool.getCurrentUser();
    if (!user) return resolve(null);
    user.getSession((err: Error | null, session: CognitoUserSession | null) => {
      if (err || !session?.isValid()) return resolve(null);
      resolve(session.getIdToken().getJwtToken());
    });
  });
}
